var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9316 5.04766L12.548 0.896875C12.3703 0.360937 11.8699 0 11.3039 0H7.4375V5.25H13.9645C13.9535 5.18164 13.9535 5.11328 13.9316 5.04766ZM6.5625 0H2.69609C2.13008 0 1.62969 0.360937 1.45195 0.896875L0.0683594 5.04766C0.0464844 5.11328 0.0464844 5.18164 0.0355469 5.25H6.5625V0ZM0 6.125V12.6875C0 13.4121 0.587891 14 1.3125 14H12.6875C13.4121 14 14 13.4121 14 12.6875V6.125H0Z",
    fill: "#89929E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackages);
export default __webpack_public_path__ + "static/media/packages.523e77f8ccccc730e7dedca3fd316874.svg";
export { ForwardRef as ReactComponent };